@if (showTrigger()) {
  <se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="open($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="edit"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="Edit variant inventory"></se-fe-icon>
  </se-fe-modal-button>
}

<se-fe-modal seFeDataSize="large" #inventoryModal (seFeAfterClose)="reset()">
  <div seFeModalHeader>
    <div class="inventory-modal-header">
      <h2 id="inventory-modal-title" class="se-fe-modal__title inventory-modal-title">
        Edit Product Variant Inventory
      </h2>
      <se-fe-icon-button (click)="close()">
        <se-fe-icon
          seFeDataName="remove"
          seFeDataSize="500"
          seFeDataColor="default"
          seFeDataAriaLabel="Close"></se-fe-icon>
      </se-fe-icon-button>
    </div>
  </div>

  <se-fe-modal-content>
    <!-- Keep these actions custom: seFeDataActions can throw NG0100 when form state changes during save. -->
    @if (inventoryModal.isOpen || inventoryModal.closing) {
      <form [formGroup]="form" [attr.aria-busy]="saving()" novalidate>
        <se-fe-table-wrapper>
          <table seFeTable title="Product variant inventory" [dataSource]="inventoryDatasource">
            <ng-container seFeColumnDef="name">
              <th seFeHeaderCell *seFeHeaderCellDef>Variant</th>
              <td seFeCell *seFeCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container seFeColumnDef="inventory">
              <th seFeHeaderCell *seFeHeaderCellDef>Quantity available</th>
              <td seFeCell *seFeCellDef="let row">
                <se-fe-form-field [seFeDataConfig]="inventoryConfig" class="inventory-field">
                  <se-fe-form-field-quantity
                    [formControlName]="'' + row.id"
                    [seFeDataMin]="inventoryMin"
                    [seFeEnableManualInput]="true"></se-fe-form-field-quantity>
                </se-fe-form-field>
              </td>
            </ng-container>
            <tr seFeHeaderRow *seFeHeaderRowDef="tableColumns"></tr>
            <tr seFeRow *seFeRowDef="let row; columns: tableColumns"></tr>
          </table>
        </se-fe-table-wrapper>
      </form>

      <se-fe-alert seFeDataType="info" class="inventory-help">
        Leave a quantity blank to make that variant unlimited. When you sell products, the quantity available is reduced
        automatically.
      </se-fe-alert>

      @if (saveError()) {
        <se-fe-alert seFeDataType="error">{{ saveError() }}</se-fe-alert>
      }

      <div class="inventory-modal-footer">
        <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
        <se-fe-button seFeDataEmphasis="high" [seFeDataIsLoading]="saving()" (click)="save()">Save</se-fe-button>
      </div>
    }
  </se-fe-modal-content>
</se-fe-modal>

<se-fe-modal #discardChangesModal [seFeDataActions]="discardChangesModalButtons">
  <div seFeModalContent>
    <h3>Discard unsaved changes?</h3>
    <p>You have unsaved changes. Are you sure you want to discard them?</p>
  </div>
</se-fe-modal>

<se-fe-modal #inventoryConflictModal [seFeDataActions]="inventoryConflictModalButtons">
  <div seFeModalContent>
    <h3>Quantity changed while you were editing</h3>
    <p>You changed the quantity of the following variants sold before you saved. What would you like to do?</p>
  </div>
</se-fe-modal>
